export const getPersonAbbreviation = (surname,name) =>surname[0] + name[0]